<template>
  <div v-if="viewType === 'SETTING'">
    <div class="title-bar title-h4">Top/Bottom N 표시 설정</div>
    <el-form :model="sortInfo" ref="sortInfoForm" label-width="120px" label-position="top">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Top/Bottom 범위" prop="sort">
            <el-select v-model="sortInfo.sort" style="width: 100%;">
              <el-option v-for="item in defaultSetList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
  <div v-else-if="viewType === 'INFO'" class="wrapper">
    <el-form-item label="Top/Bottom 범위">{{ optionInfo }}</el-form-item>
  </div>
  <div v-else class="wrapper">
    <el-form-item label="Top/Bottom 범위">{{ previewOptionInfo }}</el-form-item>
  </div>
</template>

<script>
import findIndex from 'lodash/findIndex';

export default {
  name: 'WSortComponent',
  props: {
    defaultValue: {
      type: Number,
      default: () => 5,
    },
    defaultSetList: {
      type: Array,
      default: () => [],
    },
    viewType: {
      type: String,
      default: () => 'SETTING',
    },
    optionInfo: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      sortInfo: {
        sort: '',
      },
      previewOptionInfo: '',
    };
  },
  watch: {
    defaultValue: {
      handler() {
        this.sortInfo.sort = Number(this.defaultValue);
      },
      immediate: true,
    },
  },
  methods: {
    initData() {
      this.sortInfo.sort = Number(this.defaultValue);
    },
    getData() {
      return {
        SORT: this.sortInfo.sort,
      };
    },
    getDetailData() {
      return {
        SORT: this.getTopnData(this.sortInfo.sort),
      };
    },
    getTopnData(sort) {
      const index = findIndex(this.defaultSetList, ['value', sort]);
      return this.defaultSetList[index].label;
    },
    setOptionInfo(defaultValue) {
      this.sortInfo.sort = defaultValue;
      this.previewOptionInfo = this.getDetailData().SORT;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/report/attr/SortComponent.vue